import { render, staticRenderFns } from "./serveTab7.vue?vue&type=template&id=137a4676&scoped=true"
import script from "./serveTab7.vue?vue&type=script&lang=js"
export * from "./serveTab7.vue?vue&type=script&lang=js"
import style0 from "./serveTab7.vue?vue&type=style&index=0&id=137a4676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137a4676",
  null
  
)

export default component.exports